<template>
  <v-row class="fill-height" fluid>
    <v-container fluid>
      <v-subheader class="mb-5">
        <h1>Detalles de cuenta</h1>
      </v-subheader>
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <v-container class="fill-height">
            <v-row align="center">
              <v-col
                cols="6"
                sm="6"
                md="6"
                lg="6"
                class="pa-1 d-flex justify-end"
              >
                <label class="align-self-center mr-5" style="text-align: right;"
                  >Nombre</label
                >:
              </v-col>
              <v-col cols="6" sm="6" md="6" lg="6" class="pa-1 d-flex">
                <span class="ml-5 align-self-center">{{ nombre }}</span>
              </v-col>
              <v-col
                cols="6"
                sm="6"
                md="6"
                lg="6"
                class="pa-1 d-flex justify-end"
              >
                <label class="align-self-center mr-5" style="text-align: right;"
                  >Tipo Documento</label
                >:
              </v-col>
              <v-col cols="6" sm="6" md="6" lg="6" class="pa-1 d-flex">
                <span class="ml-5 align-self-center">{{ tipoDocumento }}</span>
              </v-col>
              <v-col
                cols="6"
                sm="6"
                md="6"
                lg="6"
                class="pa-1 d-flex justify-end"
              >
                <label class="align-self-center mr-5" style="text-align: right;"
                  >Nro. Documento</label
                >:
              </v-col>
              <v-col cols="6" sm="6" md="6" lg="6" class="pa-1 d-flex">
                <span class="ml-5 align-self-center">{{ documento }}</span>
              </v-col>
              <v-col
                cols="6"
                sm="6"
                md="6"
                lg="6"
                class="pa-1 d-flex justify-end"
              >
                <label class="align-self-center mr-5" style="text-align: right;"
                  >Teléfono</label
                >:
              </v-col>
              <v-col cols="6" sm="6" md="6" lg="6" class="pa-1 d-flex">
                <span class="ml-5 align-self-center" style="width: 250px;">
                  <template v-if="!edicion">{{ telefono }}</template>
                  <v-text-field
                    @keyup.enter="guardar()"
                    dense
                    hide-details
                    outlined
                    placeholder="Ingrese nuevo teléfono"
                    required
                    v-else
                    v-model="telefono"
                  ></v-text-field>
                </span>
              </v-col>
              <v-col
                cols="6"
                sm="6"
                md="6"
                lg="6"
                class="pa-1 d-flex justify-end"
              >
                <label class="align-self-center mr-5" style="text-align: right;"
                  >Correo</label
                >:
              </v-col>
              <v-col cols="6" sm="6" md="6" lg="6" class="pa-1 d-flex">
                <span class="ml-5 align-self-center" style="width: 250px;">
                  <template v-if="!edicion">{{ correo }}</template>
                  <v-text-field
                    @keyup.enter="guardar()"
                    dense
                    hide-details
                    outlined
                    placeholder="Ingrese nuevo correo"
                    required
                    v-else
                    v-model="correo"
                  ></v-text-field>
                </span>
              </v-col>
              <v-col
                cols="6"
                sm="6"
                md="6"
                lg="6"
                class="pa-1 d-flex justify-end"
              >
                <label class="align-self-center mr-5" style="text-align: right;"
                  >Usuario</label
                >:
              </v-col>
              <v-col cols="6" sm="6" md="6" lg="6" class="pa-1 d-flex">
                <span class="ml-5 align-self-center">{{ usuario }}</span>
              </v-col>
              <v-col
                cols="6"
                sm="6"
                md="6"
                lg="6"
                class="pa-1 d-flex justify-end"
              >
                <label class="align-self-center mr-5" style="text-align: right;"
                  >Contraseña</label
                >:
              </v-col>
              <v-col cols="6" sm="6" md="6" lg="6" class="pa-1 d-flex">
                <span class="ml-5 align-self-center" style="width: 250px;">
                  <template v-if="!edicion">{{ password }}</template>
                  <v-text-field
                    :append-icon="
                      pass_valido
                        ? ''
                        : show_password
                        ? 'mdi-eye'
                        : 'mdi-eye-off'
                    "
                    :type="show_password ? 'text' : 'password'"
                    @focus="passwordFocus()"
                    @click:append="show_password = !show_password"
                    @keyup.enter="guardar()"
                    @keyup="validarPass()"
                    dense
                    hide-details
                    maxlength="12"
                    outlined
                    placeholder="Ingrese nueva contraseña"
                    required
                    v-else
                    v-model="password"
                  ></v-text-field>
                </span>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
        <v-col cols="12" sm="12" md="12">
          <v-row>
            <v-spacer></v-spacer>
            <v-btn
              small
              color="primary"
              class="mr-4"
              @click="edicion = true"
              v-if="vista.escritura && !edicion"
              >Editar</v-btn
            >
            <v-btn
              small
              color="primary"
              class="mr-4"
              @click="guardar()"
              v-if="vista.escritura && edicion"
              >Guardar</v-btn
            >
            <v-btn
              small
              color="primary"
              class="mr-4"
              @click="cancelar()"
              v-if="vista.escritura && edicion"
              >Cancelar</v-btn
            >
            <v-spacer></v-spacer>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
const PASS_PLACEHOLDER = "********************";
export default {
  name: "Cuenta",
  data: () => ({
    edicion: false,
    usuario: "",
    password: "",
    nombre: "",
    tipoDocumento: 0,
    documento: "",
    correo: "",
    pass_valido: false,
    loading: false,
    telefono: "",
    vista: {},
    show_password: false
  }),
  computed: {
    ...mapGetters(["getToken"])
    // etcTipoDoc() {
    //   switch (this.tipoDocumento) {
    //     case 1:
    //       return "DNI";
    //     case 6:
    //       return "RUC";
    //     default:
    //       return "";
    //   }
    // }
  },
  methods: {
    ...mapActions(["setToken", "showAlerta2", "hideAlerta2"]),
    passwordFocus() {
      if (this.pass_valido) {
        this.password = "";
      }
    },
    async loadVista() {
      let respuesta;
      try {
        respuesta = await axios.get(
          process.env.VUE_APP_BASE_PATH +
            `/api/usuario/ObtenerVista?vista=CUENTA`,
          {
            headers: { Authorization: `Bearer ${this.getToken}` }
          }
        );
      } catch (error) {
        if (error.response.status == 400) {
          this.showAlerta2({
            mensaje: error.response.data.error_description,
            tipo: 3
          });
        } else {
          this.salir();
        }
        return;
      }

      this.vista = respuesta.data;
    },
    async loadUsuario() {
      let respuesta;
      try {
        respuesta = await axios.get(
          process.env.VUE_APP_BASE_PATH + `/api/usuario/obtener?username=`,
          {
            headers: { Authorization: `Bearer ${this.getToken}` }
          }
        );
      } catch (error) {
        if (error.response.status == 400) {
          this.showAlerta2({
            mensaje: error.response.data.error_description,
            tipo: 3
          });
        } else {
          this.salir();
        }
        return;
      }

      console.log(respuesta.data);

      this.pass_valido = true;
      this.usuario = respuesta.data.username;
      this.nombre = respuesta.data.nombres;
      this.tipoDocumento = respuesta.data.tipo_documento_desc;
      this.documento = respuesta.data.documento;
      this.password = PASS_PLACEHOLDER;
      this.correo = respuesta.data.correo;
      this.telefono = respuesta.data.telefono;
    },
    async guardar() {
      const params = {
        password: this.password,
        pass_valido: this.pass_valido,
        correo: this.correo,
        telefono: this.telefono
      };

      let respuesta;
      try {
        this.loading = true;
        respuesta = await axios.post(
          process.env.VUE_APP_BASE_PATH + "/api/usuario/GuardarCuenta",
          params,
          {
            headers: { Authorization: `Bearer ${this.getToken}` }
          }
        );
      } catch (error) {
        if (error.response.status == 400) {
          this.showAlerta2({
            mensaje: error.response.data.error_description,
            tipo: 3
          });
        } else {
          this.salir();
        }
        return;
      } finally {
        this.loading = false;
      }

      this.showAlerta2({
        mensaje: respuesta.data.mensaje,
        tipo: respuesta.data.tipo
      });

      if (respuesta.data.tipo == 0) {
        this.edicion = false;
        this.password = PASS_PLACEHOLDER;
        this.pass_valido = true;
      }
    },
    async cancelar() {
      await this.loadUsuario();
      this.edicion = false;
    },
    validarPass() {
      if (this.pass_valido === true) {
        if (this.password != PASS_PLACEHOLDER) {
          this.pass_valido = false;
        }
      }
    },
    salir() {
      this.setToken("");
      this.$router.push({ path: "/Login" });
    }
  },
  created() {
    this.loadVista();
    this.loadUsuario();
  }
};
</script>

<style>
</style>
